/* eslint-disable import/prefer-default-export */
import { GET_WHATS_NEW } from '../../types/Types';

export const whatsNew = (data) => ({
  type: GET_WHATS_NEW,
  data,
});
